// removed by extract-text-webpack-plugin
module.exports = {"form":"form-elements__form___3ijpL","field-cell":"form-elements__field-cell___1-SKR","fields":"form-elements__fields___-L2Gm","form-button":"form-elements__form-button___1hOQF","credit-card":"form-elements__credit-card___1D8Da","other-payment":"form-elements__other-payment___2Bw_j","gst":"form-elements__gst___2ImYQ","notes":"form-elements__notes___27Iga"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/form-elements.scss
// module id = 510
// module chunks = 0